<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    > 
      <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
    </div>
    <div class="text-item-value" :style="{'margin-bottom': attrObj.isCheckError ? '0' : '15px'}">
      <div @click.stop="showDialog" style="width: 100%; position: relative; margin-bottom: 5px;"> 
        <Input v-model="add"
          :readonly="true"
          placeholder="请选择省份/城市/地区"/>
        <img class="dateIcon" src="../../../../../static/runtime/images/magic/address.png" alt="" />
      </div>
      <Input v-model="answerContent.detail"
        :readonly="attrObj.disabled"
        @input="handleData"
        :rows="1"
        autosize
        label="详细地址"
        :maxlength="50"
        placeholder="请输入详细地址"/>
      <div v-if="attrObj.isCheckError" class="errorTip">{{attrObj.errorMsg}}</div>
    </div>
    <AreaSelect ref="areaSelect" @selectArea="handleGetAdd" @cancel="cancelAreaSelect"></AreaSelect>
  </div>
</template>


<script>
import { Field, Area, ActionSheet } from 'vant';
import { FormType } from '../../../../commons/commonVariables.js';
import AreaSelect from '../../../../components/modal/area-select.vue'
export default {
  components:{
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [Area.name]: Area,
    AreaSelect,
  },
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  watch: {
    attrObj: {
      handler(newList) {
        this.attrObjData = newList;
        this.dealAddressContent()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      add: '',
      attrObjData:{},
      answerContent: {
        province:"",    // 省
        city:"",        // 市
        zone:"",        // 区
        detail:"",      // 详细地址
      }
    };
  },
    //初始化后调用
  mounted() { 
    this.$nextTick(()=>{
      setTimeout(() => {
        this.attrObjData.answerContent = JSON.stringify({...this.answerContent});
      }, 50);
    });
  },
  methods: {
    dealAddressContent() {
        console.log('地址回显', this.attrObjData, this.attrObjData.disabled , this.attrObjData.answerContent);   
        if(this.attrObjData.answerContent) { 
          const answer = JSON.parse(this.attrObjData.answerContent);
          this.answerContent = {...this.answerContent, ...answer};
          if(answer && answer.province && answer.city && answer.zone) {
            this.add = `${answer.province} / ${answer.city} / ${answer.zone}`;
          }
        }
    },
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
    blur() {
      if (this.attrObjData.mustFlag=='1') {
        if (this.attrObjData.answerContent && this.attrObjData.answerContent.trim()) {
          this.$set(this.attrObjData, "isCheckError", false);
        } else {
          this.$set(this.attrObjData, "isCheckError", true);
        }
      }
    },
    /*
    * 保存选择的地址
    * @param {Array} data: 选择好的地址数据
    * @author <fangyan f84162999>
    */
    handleGetAdd(area) {
      const data = []
      area.forEach(item=>{
        const tempObj = {
          code : item.id,
          name : item.name
        }
        data.push(tempObj)
      })
      // data = [
      //   {code: '110100', name: '北京市'},
      //   {code: '110100', name: '北京市'},
      //   {code: '110108', name: '海淀区'}
      // ]
      this.add = `${data[0].name} / ${data[1].name} / ${data[2].name}`;
      this.answerContent.province = data[0].name;
      this.answerContent.city = data[1].name;
      this.answerContent.zone = data[2].name;
      this.attrObjData.answerContent = JSON.stringify({...this.answerContent});
      this.checkAddressDetail()
    },
    handleData() {
      const isDetail = this.checkAddressDetail()
      if(isDetail){
        this.checkArea()
      }
      this.attrObjData.answerContent = {};
      this.attrObjData.answerContent = JSON.stringify({...this.answerContent});
    },
    cancelAreaSelect(){
      const isArea = this.checkArea()
      if(isArea){
        this.checkAddressDetail()
      }
      this.attrObjData.answerContent = {};
      this.attrObjData.answerContent = JSON.stringify({...this.answerContent});
    },
    showDialog(){
      // 如果是显示详情，就要禁用，不要弹起省市区选择
      if(this.attrObjData && this.attrObjData.disabled){
        return
      }else{
        this.$refs.areaSelect.showDialog()
      }
    },
    // 校验省市区填没填
    checkArea(){
      if(!this.answerContent.province || !this.answerContent.city || !this.answerContent.zone ){
          this.$set(this.attrObjData, "isCheckError", true);
          this.$set(this.attrObjData, "errorMsg", '请选择地区');
          return false
      }else{
        this.$set(this.attrObjData, "isCheckError", false);
        this.$set(this.attrObjData, "errorMsg", '');
        return true
      }
    },
    checkAddressDetail(){
      if( !this.answerContent.detail ){
          this.$set(this.attrObjData, "isCheckError", true);
          this.$set(this.attrObjData, "errorMsg", '请输入详细地址');
          return false
      }else if(this.answerContent.detail.length<5 ) {
          this.$set(this.attrObjData, "isCheckError", true);
          this.$set(this.attrObjData, "errorMsg", '详细地址不能小于五个字符');
          return false
      }else{
        this.$set(this.attrObjData, "isCheckError", false);
        this.$set(this.attrObjData, "errorMsg", '');
        return true
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .textarea_value {
    /deep/ .van-cell.van-field {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      &:hover {
        border-color: #57a3f3;
      }
      &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(45,140,240,.2);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/address.vue